import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { returnSaleNote } from "../models/sale/return-sale-note.model";
import { ApiService } from "./api.service";

@Injectable({
    providedIn: 'root'
  })
  export class RefundService { 
    constructor(private apiService: ApiService) { }

    executeSaleNoteRefund(returnSaleNote: returnSaleNote): Observable<any> {
        return this.apiService.post(`${(this.apiService.dispatch)}/returnProducts/`, returnSaleNote);
    }
  }